import * as React from "react";
import { makeStyles, Text, Image } from "@fluentui/react-components";
import { centered, flexColumn } from "../../styles/GlobalStyles";
import { CardSection } from "../../components/CardSection";

const useStyles = makeStyles({
    flexColumn,
    centered,
    container: {
        display: "flex",
        flexDirection: "column",
        gap: "2rem",
        padding: "2rem clamp(1rem, 5vw, 4rem)",
        width: "80%",
        margin: "0 auto",
        maxWidth: "1400px",
    },
    ul: {
        paddingLeft: "1.25rem",
        marginTop: "0.5rem",
        marginBottom: "0.5rem",
    }
});

export const Id = "11b2a578-a553-42f4-b69a-81548a99fc8b";
export const Title = "How to import a license key?";
export const Subtitle = "Import of licenses into publishers";
export const Description = "Find out how to import license keys into your publisher";
export const Keywords = ["license", "key", "import", "create", "trial", "publisher"];

export const Component: React.FC = React.memo(() => {
    const styles = useStyles();

    return (
        <>
            <div className={styles.container}>
                <CardSection title="Scenarios">
                    <Text size={400}>
                        PCFs and canvas apps protected by Ianus Guard show a dialog when no license is found.
                        In this dialog you can directly enter the key and the appropriate license record is created automatically.
                        For scenarios where this is not possible, you can create the license record manually.
                        We will cover both scenarios separately below.
                    </Text>
                </CardSection>
    
                <CardSection title="Missing license dialog is available">
                    <Text>
                        When using a Ianus Guard protected component for the first time or when the license expired, you see an error message similar to the following:
                        <br />
                        <br />
                        <Image
                            className={styles.centered}
                            alt="Ianus Guard missing license"
                            width="75%"
                            src="/assets/knowledgearticle/missing-license.png"
                        />
                        <br />
                        <br />
                        In that case, when clicking on the "Set License" button a dialog with an input for your key will show up:
                        <br />
                        <br />
                        <Image
                            className={styles.centered}
                            alt="Ianus Guard license entry"
                            width="75%"
                            src="/assets/knowledgearticle/license-entry.png"
                        />
                        <br />
                        <br />
                        After pasting your key and clicking "Submit", your license will be saved and validated. The underlying component should then render.
                        You successfully imported your license key.
                        If available, the underlying component may feature a "Show license" button, allowing you to see your license information and update your key at any point of time:
                        <br />
                        <br />
                        <Image
                            className={styles.centered}
                            alt="Ianus Guard license dialog"
                            width="75%"
                            src="/assets/knowledgearticle/license-dialog.png"
                        />
                    </Text>
                </CardSection>

                <CardSection title="Manual license creation">
                    <Text>
                        When manually creating a license, you can just open a create form for a license record and paste the key.
                        You do not need to input anything for name, identifier and expiry, as this will be done automatically by a plugin on save.
                    </Text>
                </CardSection>
            </div>
        </>
    );    
});